<template>
  <span
    :class="[
      'inline-flex items-center gap-1 font-medium rounded-full',
      sizeClasses,
      textColor,
      bgColor
    ]"
    :style="customStyles"
  >
    <slot name="icon" />
    {{ text }}
    <slot />
  </span>
</template>

<script setup>
  import { computed } from 'vue';

  const props = defineProps({
    text: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'md',
      validator: (value) => ['xs', 'sm', 'md', 'lg'].includes(value)
    },
    textColor: {
      type: String,
      default: 'text-primary'
    },
    bgColor: {
      type: String,
      default: 'bg-secondary'
    },
    customStyles: {
      type: Object,
      default: () => ({})
    }
  });

  const sizeClasses = computed(() => {
    const sizes = {
      xs: 'px-2 py-0.5 text-xs',
      sm: 'px-2.5 py-0.5 text-xs lg:text-md',
      md: 'px-2 py-0.5 lg:px-3 lg:py-1 text-xs lg:text-md',
      lg: 'px-4 py-1.5 text-xs lg:text-base'
    };
    return sizes[props.size];
  });
</script>
